<template>
    <div>
        <CCol sm="12">
            <CCard class="b-20" style="border:none">
                <h3 class="custom-40px-600 text-center mt-5">How it works for company</h3>
                <p class="custom-14px-600 font-color-98A2B3 text-center mb-5">Get to know the talented individuals driving our company forward.</p>
    
    
                <CCol sm="12" class="m-2">
                    <CRow>
                        <CCol sm="5" class="text-right">
                            <img src="../assets/img/co1.png" style="max-width:80%;border-radius:10px"/>
                        </CCol>
                        <CCol sm="2" class="text-center d-flex flex-column align-items-center">
                            <img src="../assets/img/Step1.png" width="50px" />
                            <div style="width: 1px; flex-grow: 1; background-color: #928AFD; margin-top: 0px;"></div>
                        </CCol>
                        <CCol sm="5">
                            <h3 class="custom-14px-500 font-color-A3A4A9">STEP 1</h3>
                            <h3 class="custom-32px-600 text-left">
                                Initial Dashboard Setup
                            </h3>
                            <p class="custom-16px-400 font-color-51575D text-left">
                                Access the dashboard and navigate to the Settings section.
                            </p>
                        </CCol>
                        <CCol sm="5" class="text-right mt-3"> 
                            <h3 class="custom-14px-500 font-color-A3A4A9">STEP 2</h3>
                            <h3 class="custom-32px-600 text-right">
                                Customize Questions
                            </h3>
                            <p class="custom-16px-400 font-color-51575D text-right">
                                <ul>
                                    <li> Go to the Customized Question tab and select Add Question.</li>
                                    <li>Choose the desired category under "Career Field for the Interview" (e.g., Surveying) and proceed.</li>
                                </ul>
                            </p>
                        </CCol>
                        <CCol sm="2" class="text-center d-flex flex-column align-items-center">
                            <img src="../assets/img/Step2.png" width="50px" />
                            <div style="width: 1px; flex-grow: 1; background-color: #928AFD; margin-top: 0px;"></div>
                        </CCol>
                        <CCol sm="5">
                            <img src="../assets/img/co2.png" style="max-width:80%;border-radius:10px"/>
                        </CCol>
                        <CCol sm="5" class="text-right">
                            <img src="../assets/img/co3.png" style="max-width:80%;border-radius:10px"/>
                        </CCol>
                        <CCol sm="2" class="text-center d-flex flex-column align-items-center">
                            <img src="../assets/img/Step3.png" width="50px" />
                            <div style="width: 1px; flex-grow: 1; background-color: #928AFD; margin-top: 0px;"></div>
                        </CCol>
                        <CCol sm="5">
                            <h3 class="custom-14px-500 font-color-A3A4A9 mt-3">STEP 3</h3>
                            <h3 class="custom-32px-600 text-left">
                                Create Questions
                            </h3>
                            <p class="custom-16px-400 font-color-51575D text-left">
                                <ul>
                                    <li> Input the question, expected answer, and optional notes.</li>
                                    <li>Specify the maximum timer and add additional questions if needed.</li>
                                    <li>Repeat the process for various categories (Technical, Behavior, Stress, and Assessment). Skip unnecessary sections as indicated.</li>
                                </ul>
                            </p>
                        </CCol>
                        <CCol sm="5" class="text-right">
                            <h3 class="custom-14px-500 font-color-A3A4A9 mt-3">STEP 4</h3>
                            <h3 class="custom-32px-600 text-right">
                                Configure Question Settings
                            </h3>
                            <p class="custom-16px-400 font-color-51575D text-right">
                                <ul>
                                    <li>Define parameters such as Start Date, Expiry Date, and Score Category.</li>
                                    <li>Select the relevant category and save the changes.</li>
                                </ul>
                            </p>
                        </CCol>
                        <CCol sm="2" class="text-center d-flex flex-column align-items-center">
                            <img src="../assets/img/Step4.png" width="50px" />
                            <div style="width: 1px; flex-grow: 1; background-color: #928AFD; margin-top: 0px;"></div>
                        </CCol>
                        <CCol sm="5">
                            <img src="../assets/img/co4.png" style="max-width:80%;border-radius:10px"/>
                        </CCol>
                        <CCol sm="5" class="text-right">
                            <img src="../assets/img/co5.png" style="max-width:80%;border-radius:10px"/>
                        </CCol>
                        <CCol sm="2" class="text-center d-flex flex-column align-items-center">
                            <img src="../assets/img/Step5.png" width="50px" />
                            
                        </CCol>
                        <CCol sm="5">
                            <h3 class="custom-14px-500 font-color-A3A4A9 mt-3">STEP 5</h3>
                            <h3 class="custom-32px-600 text-left">
                                Publish and Share Code
                            </h3>
                            <p class="custom-16px-400 font-color-51575D text-left">
                                <ul>
                                    <li>Optionally input the objective.</li>
                                    <li>SFinalize by clicking Publish to generate a sharable code.</li>
                                </ul>
    
    
    
                            </p>
                        </CCol>
                    </CRow>
                </CCol>
            </CCard>
        </CCol>
    </div>
</template>


<script>
import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
    name: "Login",
    components: {
    },

    data() {
        return {

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
    },
    methods: {
       
    },

};
</script>
